import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const manifestationTypeDefinition = definitionFactory({
  key: 'from_developer',
  mapper: jsonQueryValue => {
    if (jsonQueryValue === true) {
      return [
        {
          label: 'От застройщика',
          value: true,
        },
      ];
    }

    if (jsonQueryValue === false) {
      return [
        {
          label: 'От агента или собственника',
          value: false,
        },
      ];
    }

    return [];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'from_developer', options);
  },
});
